import React from "react";
import Navbar from "./Navbar";
import Card from "./Card";
// import "./index.css"
import { WavyBackground } from "./ui/WavyBackground";
import {
  doc,
  setDoc,
  updateDoc,
  collection,
  getDoc,
  onSnapshot,
} from "firebase/firestore";
import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "./firebase";
import { useState } from "react";
import Widgetsidebar from "./Widgetsidebar";
import InvitePopup from "./ui/invite-popup";
import { Button } from "./ui/button";
import { useRecoilState, useSetRecoilState } from "recoil";
import Completion from "./spaces/run/completion";
import { completionModalState } from "../recoilState/completionModalState";
import InviteAnimatePopup from "./ui/invite-animate-popup";
import SocialPopup from "./social-popup";
import YouTubeBackground, { isYouTubeUrl } from "./YouTubeBackground";
import Seo from "./Seo";
// import Draggable from "react-draggable";
// import { useRef } from "react";

function App() {
  const defaultLink = "https://i.ibb.co/k8t6STs/owall-7.jpg";
  const [customlink, setcustomlink] = useState(defaultLink);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [timerrunning, setTimerrunning] = useState(false);
  const [user] = useAuthState(auth);
  const [completionModal, setCompletionModal] =
    useRecoilState(completionModalState);
  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      // If currently not in fullscreen, enter fullscreen
      document.documentElement.requestFullscreen().then(() => {
        setIsFullscreen(true);
      });
    } else {
      // If currently in fullscreen, exit fullscreen
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      });
    }
  };
  // const setIsOpen = useSetRecoilState(modalState);
  useEffect(() => {
    const prevWallpaper = localStorage.getItem("wallpaper");
    console.log("wallpaper changed");
    if (prevWallpaper && customlink === defaultLink) {
      console.log("wallpaper applying");
      setcustomlink(prevWallpaper);
    } else if (customlink && prevWallpaper !== customlink) {
      console.log("wallpaper stored");
      localStorage.setItem("wallpaper", customlink);
    }
  }, [customlink]);
  const ytBackground = isYouTubeUrl(customlink);
  return (
    <div
      className="home "
      style={{
        backgroundImage: ytBackground
          ? "none"
          : customlink && customlink.length !== 0
            ? `url(${customlink})`
            : "url('./images/homeimge4.webp')",
        backgroundColor: ytBackground ? "#000" : undefined,
      }}
    >
      <Seo
        path="/"
        title="Animedoro Study & Focus Timer"
        description="Otakufy is the free Animedoro timer: study or focus in 40–60 min sprints, then reward yourself with a 20 min anime break. Customizable focus timer, study rooms, LoFi music, stats & streaks."
      />
      {ytBackground && <YouTubeBackground url={customlink} />}
      <Completion
        time={completionModal.duration}
        isOpen={completionModal.open}
        setIsOpen={(value) => {
          setCompletionModal((p) => ({ ...p, open: value }));
        }}
      />
      <Navbar timerrunning={timerrunning} />
      <SocialPopup />
      <InvitePopup user={user} />
      <InviteAnimatePopup user={user} />
      {/* <Button onClick={()=>{setIsOpen(true)}}>MODAL</Button> */}
      <Card
        setcustomlink={setcustomlink}
        setTimerrunning={setTimerrunning}
        handleFullscreenToggle={handleFullscreenToggle}
        isFullscreen={isFullscreen}
      />
      <a
        href="https://www.buymeacoffee.com/divyamauto5"
        target="_blank"
        rel="noreferrer"
      >
        <img
          className="buycoffee"
          src="./images/bmc-logo-yellow.png"
          alt="bmc"
        />
      </a>
    </div>
  );
}

export default App;
